document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth < 1024) {
    document.querySelectorAll(".footer-menu_title").forEach(title => {
      title.addEventListener("click", function () {
        const parentMenu = this.closest(".footer-sect--menu");
        if (parentMenu) {
          parentMenu.classList.toggle("collapse--menu");
        }
      });
    });
  }
});
